import { jwtDecode } from 'jwt-decode';

import { DecodedToken, DefaultResponse } from '../shared.types';

import { CorporateRegisterData, SendJoiningLinkData } from './signUp.types';

import axiosServer from '@/services/axios';
import { useAuthStore } from '@/stores/useAuthStore.ts';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/signup';

export const sendJoiningLink = async (
  reqData: SendJoiningLinkData
): Promise<DefaultResponse> => {
  try {
    const res = await axiosServer.post(
      `${endpoint}/send-joining-link`,
      reqData
    );

    if (!res.data.success) {
      return res.data;
    }

    return res.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const signUpCorporateUser = async (
  data: CorporateRegisterData,
  joiningToken: string
): Promise<DefaultResponse> => {
  try {
    const { confirmPassword, ...sanitizedData } = data;
    const res = await axiosServer.post(
      `${endpoint}/corporate?token=${joiningToken}`,
      sanitizedData
    );

    if (!res.data.success) {
      return res.data;
    }

    const { token } = res.headers;
    const decoded = jwtDecode<DecodedToken>(token);

    const auth = useAuthStore.getState();
    auth.login(token, '', '', decoded.role);

    return res.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const verifyGolferAccount = async (
  token: string
): Promise<DefaultResponse> => {
  try {
    const res = await axiosServer.post(
      `${endpoint}/verify?token=${encodeURIComponent(token)}`
    );

    return res.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
